import React from "react";
import Shape1 from "../../../assets/images/icon-3.png";
import Shape2 from "../../../assets/images/icon-4.png";
import Shape3 from "../../../assets/images/icon-5.png";
import Shape12 from "../../../assets/images/shape-12.png";
import Service1 from "../../../assets/images/Assitance.jpg";
import Service2 from "../../../assets/images/Guidance.jpg";
import Service3 from "../../../assets/images/Driving_Course.jpg";
import Slider from "react-slick";
import { config } from "../config";

const ServiceSection = () => {
  const Servcices = [
    {
      title: "Driving Lessons",
      description:
        "Master the art of driving with our expertly designed courses tailored to your learning pace. From beginner lessons to advanced techniques, we ensure you're road-ready with confidence.",
      image: Service3,
      icon: Shape3,
      link: `${config.appUrl}courses`,
    },
    {
      title: "Driving Licence Assistance",
      description:
        "Let us guide you through the process of obtaining your driving licence with ease. We’ll support you every step of the way to ensure a smooth and hassle-free experience. ",
      image: Service1,
      icon: Shape1,
      link: `${config.appUrl}courses`,
    },
    {
      title: "Vehicle Insurance Guidance",
      description:
        "Stay protected on the road with the right insurance. We provide assistance in finding the best insurance options to suit your needs and budget.",
      image: Service2,
      icon: Shape2,
      link: `${config.appUrl}courses`,
    },
  ];

  return (
    <div>
      <section className="service-section">
        <div className="shape">
          <div
            className="shape-1 float-bob-x"
            style={{ backgroundImage: `url(${Shape12})` }}
          ></div>
          <div
            className="shape-2 float-bob-x"
            style={{ backgroundImage: `url(${Shape12})` }}
          ></div>
        </div>
        <div className="auto-container">
          <div className="sec-title light centred">
            <h2>Services customised for you</h2>
          </div>
          <div className="row">
            {Servcices?.map((serv, i) => {
              return (
                <div
                  key={i}
                  className="service-block-one col-xl-4 mb-md-0 mb-5"
                  style={{ paddingRight: "30px" }}
                >
                  <div className="inner-box">
                    <div className="image-box">
                      <div className="icon-box">
                        <img src={serv?.icon} alt="Services Icon" />
                      </div>
                      <figure className="image">
                        <img src={serv?.image} alt={`${serv?.title}`} />
                      </figure>
                    </div>
                    <div className="lower-content">
                      <div className="text">
                        <h4>
                          <a href="#">{serv.title}</a>
                        </h4>
                        <p className="">{serv?.description}</p>
                      </div>
                      <div className="lower-box">
                        <ul className="arrow-icon clearfix">
                          <li>
                            <i className="bi bi-chevron-right"></i>
                          </li>
                          <li>
                            <i className="bi bi-chevron-right"></i>
                          </li>
                          <li>
                            <i className="bi bi-chevron-right"></i>
                          </li>
                          <li>
                            <i className="bi bi-chevron-right"></i>
                          </li>
                          <li>
                            <i className="bi bi-chevron-right"></i>
                          </li>
                        </ul>
                        <div className="link">
                          <a href={serv?.link}>
                            <i className="bi bi-chevron-right"></i>Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceSection;
